module.exports = __webpack_public_path__ + "static/4-2883cc6f59162c4e650a8621a5356b19.jpg";